import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setActiveTitle } from '../../actions/uiActions';
import logError from '../../utils/error';
import Error500 from '../Error500';
import CoverTitle from './CoverTitle';
import GridCoverTitle from './GridCoverTitle';
import PageTitle from './PageTitle';
import MediaTitle from './MediaTitle';
import PlaylistTitle from './PlaylistTitle';
import PinMapTitle from './PinMapTitle';
import TimelineTitle from './TimelineTitle';
import ContextualizedVideoTitle from './ContextualizedVideoTitle';
import ContextualizedAudioQATitle from './ContextualizedAudioQATitle';
import TopicTreeTitle from './TopicTreeTitle';
import PageGroupTitle from './PageGroupTitle';


class Title extends Component {
  constructor (props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidMount () {
    const { actions, uid } = this.props;
    actions.setActiveTitle(uid);
  }

  componentDidUpdate (prevProps) {
    const { actions, uid } = this.props;
    if (uid !== prevProps.uid) {
      actions.setActiveTitle(uid);
    }
  }

  componentDidCatch (error, info) {
    console.error(error);
    logError(error, info);
    this.setState({ hasError: true });
  }

  render () {
    const { uid, type, actions, ...rest } = this.props;
    if (this.state.hasError) {
      return <Error500 />;
    }

    switch (type.toLowerCase()) {
      case 'cover':
        // fall through
      case 'ccny cover':
        return <CoverTitle uid={uid} {...rest} />;
      case 'ccny grid cover':
        return <GridCoverTitle uid={uid} {...rest} />;
      case 'ccny page':
        return <PageTitle uid={uid} {...rest} />;
      case 'video':
      case 'audio':
      case 'image':
        return <MediaTitle uid={uid} {...rest} />;
      case 'playlist':
        return <PlaylistTitle uid={uid} {...rest} />;
      case 'pin map':
        return <PinMapTitle uid={uid} {...rest} />;
      case 'timeline':
        return <TimelineTitle uid={uid} {...rest} />;
      case 'contextualized_video':
        return <ContextualizedVideoTitle uid={uid} {...rest} />;
      case 'ccny audio & data':
        return <ContextualizedAudioQATitle uid={uid} {...rest} />;
      case 'ccny topic tree':
        return <TopicTreeTitle uid={uid} {...rest} />;
      case 'ccny page group':
        return <PageGroupTitle uid={uid} {...rest} />;
      default:
        return <div>{rest.name}</div>;
    }
  }
}

Title.propTypes = {
  uid: PropTypes.string,
  type: PropTypes.string,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ setActiveTitle }, dispatch),
});

export default withRouter(connect(null, mapDispatchToProps)(Title));



// WEBPACK FOOTER //
// ./src/components/Title/index.js